import { AxiosResponse } from "axios";
import { CouponDetailed, Coupon } from "@/models/coupon-check";
import { CouponMapping, CouponMapDto } from "@/models/coupon-mapping";
import { RedeemResponseData, RedeemableDetailsResponseData, RedeemableDetails } from "@/models/redeem-coupon";
import { MobileDaumResponseData } from "@/models/daum-coupon";
import axiosGlobal from "@/main";
import { CouponsResponse } from "@/models/alcoguru";

interface AxiosResponseExtended<T> extends AxiosResponse<T> {
  message?: string;
  errors?: string;
}

export default {
  async mapCoupon(couponMapInfo: CouponMapping): Promise<boolean> {
    const data = {
      auth_id: couponMapInfo.auth_id,
      gcn: couponMapInfo.barcode,
      date_from: new Date(couponMapInfo.startDate ?? "").toLocaleDateString("fr-CA"),
      coupon_id: couponMapInfo.couponId,
      special_action_id: couponMapInfo.specialActionId,
      // comment: couponMapInfo.comment,
    };
    const response = await axiosGlobal.post(`/api/mapmetro5002/integration/add_3v_compaings/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data?.data.result == true;
  },

  async unmapCoupon(couponMapInfo: CouponMapping) {
    const data = {
      auth_id: couponMapInfo.auth_id,
      gcn: couponMapInfo.barcode,
      date_from: new Date(couponMapInfo.startDate ?? "").toLocaleDateString("fr-CA"),
      // comment: couponMapInfo.comment,
    };
    const response = await axiosGlobal.post(`/api/mapmetro5002/integration/del_3v_compaings/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data?.data.result == true;
  },

  async getCouponDetailed(coupon: Coupon): Promise<CouponDetailed> {
    let result: CouponDetailed = new CouponDetailed();
    try {
      const response = await axiosGlobal.get<CouponDetailed>(
        `/api/proxyMetroLink/campaign?gcn=${coupon.gcn}&validFrom=${new Date(
          coupon.campaignStart!
        ).toISOString()}`
      );
      result = response.data;
    } catch {
      console.error("error");
    }
    return result;
  },

  async getAllCoupons(auth_id: string): Promise<CouponsResponse> {
    const result = await axiosGlobal.get<CouponsResponse>(
      `/api/mapmetro5002/integration/get_all_coupons/?auth_id=${auth_id}`
    );
    return result.data;
  },

  async getRedeemables(authId: string): Promise<RedeemResponseData> {
    let response: AxiosResponse<AxiosResponseExtended<RedeemResponseData>>;
    try {
      response = await axiosGlobal.get<AxiosResponseExtended<RedeemResponseData>>(
        `/api/IsMetro/get_all_redeemables/?auth_id=${authId}`
      );
    } catch {
      throw new Error("Сервис временно недоступен, повторите попытку позже");
    }

    if (Object.entries(response.data.errors ?? "").length !== 0 || response.status != 200) {
      throw new Error("Ошибка обработки запроса сервиса");
    }

    return response.data.data;
  },

  async getRedeemableDetails(epc: string): Promise<RedeemableDetails> {
    const response = await axiosGlobal.get<AxiosResponseExtended<RedeemableDetailsResponseData>>(
      `/api/IsMetro/get_redeemable_details/?epc=${epc}`
    );

    if (Object.entries(response.data.errors ?? "").length !== 0 || response.status != 200) {
      throw new Error("Ошибка обработки запроса сервиса");
    }

    return response.data.data.redeemable_details;
  },

  //Временный метод для токена который используется в мобильном приложении
  async getCouponsByCardNumber(card_num: string): Promise<MobileDaumResponseData> {
    const response = await axiosGlobal.get<MobileDaumResponseData>(
      `/api/apimapmetro/coupons?card_number=${card_num}`
    );
    return response.data;
  },

  async batchMapCoupon(model: CouponMapDto): Promise<AxiosResponse> {
    const bodyFormData = new FormData();
    Object.entries(model).forEach(([key, item]) => {
      if (item != undefined) {
        if (key === "startDate") {
          bodyFormData.append(key, new Date(item ?? "").toLocaleDateString("fr-CA"));
        } else {
          bodyFormData.append(key, item);
        }
      }
    });
    const response = await axiosGlobal.post(`/api/mapcoupon/update_mapcoupons`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  async getCouponDetails(gcn: string): Promise<AxiosResponse> {
    const searchData = {
      filter: {
        countryCode: "RUS",
        query: gcn,
        includeSupplierCampaigns: false,
      },
      pagination: {
        skip: 0,
        size: 10,
      },
      sorting: {
        fieldName: "campaignStart",
        ascending: false,
      },
    };
    const response = await axiosGlobal.post("/api/proxyMetroLink/campaigns/search", searchData);
    return response.data;
  },
  async isCouponActive(gcn: string): Promise<boolean> {
    const searchData = {
      filter: {
        countryCode: "RUS",
        query: gcn,
        status: "ACTIVE",
      },
      pagination: {
        skip: 0,
        size: 10,
      },
      sorting: {
        fieldName: "campaignStart",
        ascending: false,
      },
    };
    const response = await axiosGlobal.post("/api/proxyMetroLink/campaigns/search", searchData);
    return response.data.campaigns.length > 0;
  },
};
